// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{overflow-x:hidden}#lt-yantr{overflow-x:inherit}@media (max-width: 992px){#lt-yantr.auto-loan-calc .chart-parent .donut-inner label{font-size:14px}}#lt-yantr.auto-loan-calc #chartjs-tooltip-payoff{text-align:left}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
